import React from 'react';

import Table from '../../../../components/table/Table';
import columns from './columns';
import { SUB_CATEGORY_LIST_FILTER_OPTION_MODEL, SUB_CATEGORY_LIST_SORT_OPTION_MODEL } from './constants';
import './SubCategoryDetail.scss';

const SubCategoryListView = (props) => {
  const { categoryList, filterOption, sortOption, dispatchFilter, ...res } = props;

  const hasFilterResult = filterOption.id !== null || filterOption.name !== null;

  return (
    <Table
      className="sub-category-list"
      emptyText={hasFilterResult ? '데이터가 존재하지 않습니다.' : '등록 된 하위 카테고리 정보가 없습니다.'}
      columns={(utils) => columns({ ...res, ...utils })}
      data={categoryList}
      initialOption={{
        filterOption: SUB_CATEGORY_LIST_FILTER_OPTION_MODEL,
        sortOption: SUB_CATEGORY_LIST_SORT_OPTION_MODEL,
      }}
      filterOption={filterOption}
      sortOption={sortOption}
      getList={dispatchFilter}
    />
  );
};

export default SubCategoryListView;
